export enum AuthRoles {
  ASA_Admin = 'asa-admin',
  ASTRA_Admin = 'astra-admin',
  NHK_Admin = 'nhk-admin',
  NHK_User = 'nhk-user',
  STVA_Admin = 'stva-admin',
  Vision_User = 'vision-user',
  Vision_Admin = 'vision-admin',
}
